import React, { useEffect, useState, useContext } from "react";
import {
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Table,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Row,
    Col
} from "reactstrap";
import { UserContext } from '../context/UserProvider';
import Buscar from '../componentes/Buscar';

import "bootstrap/dist/css/bootstrap.min.css";
import "./IncapacidadesLicenciasNomina.css";
import Swal from "sweetalert2";

export default function IncapacidadesUI(props) {
    const { user } = useContext(UserContext);
    const [incapacidades, setIncapacidades] = useState([]);
    const [Empleados, setEmpleados] = useState([]);
    const [Conceptos, setConceptos] = useState([]);
    const [CentrodeCosto, setCentrodeCosto] = useState([]);
    const [verModaltipodocumentos, setverModaltipodocumentos] = useState(false);

    const [titulobuscar, settitulobuscar] = useState("");
    const [namebuscado, setnamebuscado] = useState("");
    const [encabezadobuscar, setencabezadobuscar] = useState([]);
    const [datosbuscados, setdatosbuscados] = useState([]);
    const [formData, setFormData] = useState({
        empleado: "",
        concepto: "",
        fechainicial: "",
        dias: 0,
        fechafinal: "",
        finalizada: "",
        opcion1: "",
        opcion2: "",
        opcion3: 0,
        opcion4: 0
    });
    const [filtroEmpleado, setFiltroEmpleado] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [editando, setEditando] = useState(null);

    const cerrartodo = () => {
        settitulobuscar("");
        setencabezadobuscar([]);
        setverModaltipodocumentos(false);
        setdatosbuscados([]);
        setnamebuscado("");
    };

    useEffect(() => {
        try {
            buscarincapacidades();
            obtenerEmpleados("");
            obtenerCentrosdeCosto("");
            obtenerConceptos("");
        } catch (error) {
            console.log(error);
        }
    }, []);

    const obtenerConceptos = async (coincidencia) => {
        try {
            let dt = JSON.parse(user);
            let response = await fetch(props.servidor + '/ConceptosNominaApi/' + coincidencia + '?llave=' + dt.usuario.llaveempresa);

            if (response.ok) {
                let data = await response.json();
                setConceptos(data.filter(p => p.opcion.toLowerCase().includes("incapacidad") || p.opcion.toLowerCase().includes("licencia")));
            }
        } catch (error) {
            console.log(error);
        }
    };

    const obtenerEmpleados = async (coincidencia) => {
        try {
            let dt = JSON.parse(user);
            let response = await fetch(props.servidor + '/EmpleadosApi/' + coincidencia + '?llave=' + dt.usuario.llaveempresa);

            if (response.ok) {
                let data = await response.json();
                setEmpleados(data);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const obtenerCentrosdeCosto = async (coincidencia) => {
        try {
            let dt = JSON.parse(user);
            let response = await fetch(props.servidor + '/Ctcentrocostoapi/' + coincidencia + '?llave=' + dt.usuario.llaveempresa);

            if (response.ok) {
                let data = await response.json();
                setCentrodeCosto(data);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const buscarincapacidades = async () => {
        try {
            let dt = JSON.parse(user);
            let response = await fetch(`${props.servidor}/IncapacidadesLicenciasApi?llave=${dt.usuario.llaveempresa}`);

            if (response.ok) {
                let data = await response.json();
                setIncapacidades(data);
            } else {
                console.error("Error al cargar incapacidades:", response.statusText);
            }
        } catch (error) {
            console.error("Error al obtener datos:", error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        var updatedFormData = { ...formData, [name]: value };
        if (name=="dias") {
            updatedFormData = { ...formData, [name]: Number(value) };
        }
        // Si ya están disponibles fechainicial y dias, calcula la fecha final
        if ((name === "fechainicial" || name === "dias") && updatedFormData.fechainicial && updatedFormData.dias) {
            const fechaInicio = new Date(updatedFormData.fechainicial);
            const dias = parseInt(updatedFormData.dias, 10);

            if (!isNaN(dias)) {
                const fechaFinal = new Date(fechaInicio);
                fechaFinal.setDate(fechaInicio.getDate() + dias - 1); // -1 para incluir el día de inicio
                updatedFormData.fechafinal = fechaFinal.toISOString().split("T")[0]; // Formato YYYY-MM-DD
            }
        }

        setFormData(updatedFormData);
    };

    const handleGuardar = async () => {
        let dt = JSON.parse(user);
        const metodo = editando ? "PUT" : "POST";
        const url = "" + props.servidor + "/IncapacidadesLicenciasApi?llave=" + dt.usuario.llaveempresa + "";
        if (!Empleados.find(p=>p.codigo==formData.empleado)) {
            Swal.fire(
                'Oops!',
                'Empleado no Existe',
                'error'
            )
            return
        }
        if (!Conceptos.find(p=>p.codigo==formData.concepto)) {
            Swal.fire(
                'Oops!',
                'Concepto no Existe',
                'error'
            )
            return
        }
        if (formData.dias==0) {
            Swal.fire(
                'Oops!',
                'Dias no Pueden ser 0',
                'error'
            )
            return
        }
        if (formData.fechainicial==0) {
            Swal.fire(
                'Oops!',
                'fechainicial no Pueden estar en blanco',
                'error'
            )
            return
        }
        if (formData.fechafinal==0) {
            Swal.fire(
                'Oops!',
                'fechafinal no Pueden estar en blanco',
                'error'
            )
            return
        }
        const body2 = editando ? JSON.stringify(formData) : JSON.stringify(formData);

        try {
            const response = await fetch(url, {
                method: metodo,
                headers: { "Content-Type": "application/json;charset=utf-8" },
                body: body2
            });

            if (response.ok) {
                const dataResponse = await fetch(`${props.servidor}/IncapacidadesLicenciasApi?llave=${dt.usuario.llaveempresa}`);
                if (dataResponse.ok) {
                    const data = await dataResponse.json();
                    setIncapacidades(data);
                }

                setShowModal(false);
                setFormData({
                    empleado: "",
                    concepto: "",
                    fechainicial: "",
                    dias: 0,
                    fechafinal: "",
                    finalizada: "",
                    opcion1: "",
                    opcion2: "",
                    opcion3: 0,
                    opcion4: 0
                });
                setEditando(null);
            } else {
                console.error("Error al guardar:", response.statusText);
            }
        } catch (error) {
            console.error("Error en la solicitud:", error);
        }
    };

    const handleEditar = (incapacidad) => {
        setFormData(incapacidad);
        setEditando(true);
        setShowModal(true);
    };

    const incapacidadesFiltradas = filtroEmpleado
        ? incapacidades.filter(i => i.empleado.toLowerCase().includes(filtroEmpleado.toLowerCase()))
        : incapacidades;

    return (
        <div className="incapacidades-ui container py-4">
            <h2 className="mb-4 text-center">Gestión de Incapacidades y Licencias</h2>
            <Row className="mb-3">
                <Col>
                    <Input
                        type="text"
                        placeholder="Filtrar por empleado"
                        value={filtroEmpleado}
                        onChange={e => setFiltroEmpleado(e.target.value)}
                    />
                </Col>
                <Col xs="auto">
                    <Button color="primary" onClick={() => {
                        setFormData({
                            empleado: "",
                            concepto: "",
                            fechainicial: "",
                            dias: 0,
                            fechafinal: "",
                            finalizada: "",
                            opcion1: "",
                            opcion2: "",
                            opcion3: 0,
                            opcion4: 0
                        });
                        setShowModal(true);
                    }}>
                        Nueva Licencia - Incapacidad
                    </Button>
                </Col>
            </Row>
            <Table striped bordered responsive>
                <thead>
                    <tr>
                        <th>Empleado</th>
                        <th>Concepto</th>
                        <th>Fecha Inicial</th>
                        <th>Días</th>
                        <th>Fecha Final</th>
                        <th>Finalizada</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {incapacidadesFiltradas.map((i, index) => (
                        <tr key={index}>
                            <td>{i.empleado}</td>
                            <td>{i.concepto}</td>
                            <td>{i.fechainicial}</td>
                            <td>{i.dias}</td>
                            <td>{i.fechafinal}</td>
                            <td>{i.finalizada}</td>
                            <td>
                                <Button color="warning" size="sm" onClick={() => handleEditar(i)}>Editar</Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <Modal isOpen={showModal} toggle={() => setShowModal(false)}>
                <ModalHeader toggle={() => setShowModal(false)}>
                    {editando ? "Editar Licencia - Incapacidad" : "Nueva Licencia - Incapacidad"}
                </ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label>Empleado</Label>
                            <Input
                                name="empleado"
                                value={formData.empleado}
                                onFocus={() => {
                                    settitulobuscar("Empleados");
                                    setencabezadobuscar(["codigo", "nombre", "", ""]);
                                    setnamebuscado("empleado");
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        setverModaltipodocumentos(true);
                                        setdatosbuscados(Empleados);
                                    }
                                }}
                                onChange={handleInputChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Concepto</Label>
                            <Input
                                name="concepto"
                                value={formData.concepto}
                                onFocus={() => {
                                    settitulobuscar("Concepto");
                                    setencabezadobuscar(["codigo", "nombre", "", ""]);
                                    setnamebuscado("concepto");
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        setverModaltipodocumentos(true);
                                        setdatosbuscados(Conceptos);
                                    }
                                }}
                                onChange={handleInputChange}
                            />
                        </FormGroup>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>Fecha Inicial</Label>
                                    <Input type="date" name="fechainicial" value={formData.fechainicial} onChange={handleInputChange} />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label>Días</Label>
                                    <Input type="number" name="dias" value={formData.dias} onChange={handleInputChange} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <FormGroup>
                            <Label>Fecha Final</Label>
                            <Input disabled type="date" name="fechafinal" value={formData.fechafinal} onChange={handleInputChange} />
                        </FormGroup>
                          <FormGroup>
                                    <Label>Centro de Costo</Label>
                                    <Input name="opcion1" value={formData.opcion1} onChange={handleInputChange} />
                                </FormGroup>
                        {/* <FormGroup>
                            <Label>Finalizada</Label>
                            <Input type="select" name="finalizada" value={formData.finalizada} onChange={handleInputChange}>
                                <option value="">Seleccione</option>
                                <option value="SI">Sí</option>
                                <option value="NO">No</option>
                            </Input>
                        </FormGroup> */}
                        {/* <Row>
                            <Col>
                                <FormGroup>
                                    <Label>Opción 1</Label>
                                    <Input name="opcion1" value={formData.opcion1} onChange={handleInputChange} />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label>Opción 2</Label>
                                    <Input name="opcion2" value={formData.opcion2} onChange={handleInputChange} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>Opción 3</Label>
                                    <Input type="number" name="opcion3" value={formData.opcion3} onChange={handleInputChange} />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup>
                                    <Label>Opción 4</Label>
                                    <Input type="number" step="0.01" name="opcion4" value={formData.opcion4} onChange={handleInputChange} />
                                </FormGroup>
                            </Col>
                        </Row> */}
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
                    <Button color="primary" onClick={handleGuardar}>{editando ? "Actualizar" : "Guardar"}</Button>
                </ModalFooter>

                <Buscar
                    tituloencabezado={titulobuscar}
                    filtrar={(coincidencia) => {

                        try {
                            if (namebuscado === "empleado") {
                                const _empleados = [...Empleados];
                                setdatosbuscados(
                                    _empleados.filter(p =>
                                        p.codigo.toLowerCase().includes(coincidencia) ||
                                        p.nombre.toLowerCase().includes(coincidencia)
                                    )
                                );
                            }
                            if (namebuscado === "concepto") {
                                const _empleados = [...Conceptos];
                                setdatosbuscados(
                                    _empleados.filter(p =>
                                        p.codigo.toLowerCase().includes(coincidencia) ||
                                        p.nombre.toLowerCase().includes(coincidencia)
                                    )
                                );
                            }
                        } catch (error) {

                        }

                    }}
                    busqueda={datosbuscados}
                    encabezado={encabezadobuscar}
                    codigo={encabezadobuscar[0]}
                    nombre={encabezadobuscar[1]}
                    dato={encabezadobuscar[2]}
                    dato2={encabezadobuscar[3]}
                    verModal={verModaltipodocumentos}
                    cerrarModal={cerrartodo}
                    seleccionar={(seleccionado) => {
                        if (namebuscado === "empleado" || namebuscado === "concepto") {
                            setFormData({ ...formData, [namebuscado]: seleccionado.codigo });
                        }
                        cerrartodo();
                    }}
                />
            </Modal>
        </div>
    );
}
